import { MutableRefObject, createContext, useContext } from 'react'

import { RecordHistoryItemType } from 'types/graphql'

import { RecordTabKey } from 'src/pages/RecordPage/Record/constants'

import { SetState } from '../../../components/PlanReviewModal/PlanReviewContext'
import { RefetchFnType } from '../../../types'

export type RecordContextType = {
  orgSlug: string
  orgUuid: string
  mailerIdempotancy: string
  setMailerIdempotancy: SetState<string>
  refetch: RefetchFnType
  isUpdatingApplication: boolean
  setIsUpdatingApplication: SetState<boolean>
  updateApplicationRef: MutableRefObject<HTMLDivElement | null>
  setUpdateApplicationRef: SetState<MutableRefObject<HTMLDivElement | null>>
  setSelectedTabKey: (selectedTabKey: RecordTabKey) => void
  getIsTabKeySelected: (key: RecordTabKey) => boolean
  activityTabFilter: RecordHistoryItemType | undefined | null
  setActivityTabFilter: (filter: RecordHistoryItemType | undefined | null) => void
}

export const RecordContext = createContext<RecordContextType>({} as RecordContextType)
export const useRecordContext = () => useContext(RecordContext)
